/* tslint:disable */
/* eslint-disable */
/**
 * livechat
 * livechat API
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { KeywordUpdate } from '../models';
// @ts-ignore
import type { PaginatedVendorApiMasterOut } from '../models';
// @ts-ignore
import type { VendorApiMasterCreate } from '../models';
// @ts-ignore
import type { VendorApiMasterOut } from '../models';
// @ts-ignore
import type { VendorApiMasterRequest } from '../models';
// @ts-ignore
import type { VendorApiMasterUpdate } from '../models';
/**
 * VendorApiMasterApi - axios parameter creator
 * @export
 */
export const VendorApiMasterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new Vendor Api.
         * @param {VendorApiMasterCreate} vendorApiMasterCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVendorApi: async (vendorApiMasterCreate: VendorApiMasterCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorApiMasterCreate' is not null or undefined
            assertParamExists('createVendorApi', 'vendorApiMasterCreate', vendorApiMasterCreate)
            const localVarPath = `/api/v1/vendor-api-master`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vendorApiMasterCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Vendor Api by ID
         * @param {number} vendorApiId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVendorApi: async (vendorApiId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorApiId' is not null or undefined
            assertParamExists('deleteVendorApi', 'vendorApiId', vendorApiId)
            const localVarPath = `/api/v1/vendor-api-master/{vendor_api_id}`
                .replace(`{${"vendor_api_id"}}`, encodeURIComponent(String(vendorApiId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all unique keywords from Vendor Api.
         * @param {string | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUniqueKeywords: async (agentId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/vendor-api-master/keywords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get latest Vendor Api by keyword.
         * @param {string} keyword Comma-separated keywords
         * @param {string | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendorApiByKeyword: async (keyword: string, agentId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyword' is not null or undefined
            assertParamExists('getVendorApiByKeyword', 'keyword', keyword)
            const localVarPath = `/api/v1/vendor-api-master/get-one/by-keyword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Vendor Api detail by ID.
         * @param {number} vendorApiId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendorApiDetail: async (vendorApiId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorApiId' is not null or undefined
            assertParamExists('getVendorApiDetail', 'vendorApiId', vendorApiId)
            const localVarPath = `/api/v1/vendor-api-master/{vendor_api_id}`
                .replace(`{${"vendor_api_id"}}`, encodeURIComponent(String(vendorApiId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get paginated list of Vendor Api with search & sort.
         * @param {string | null} [agentId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [keyword] 
         * @param {string} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendorApis: async (agentId?: string | null, page?: number, pageSize?: number, keyword?: string | null, orderBy?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/vendor-api-master`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send test request using Vendor Api configuration.
         * @param {VendorApiMasterRequest} vendorApiMasterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proxyRequest: async (vendorApiMasterRequest: VendorApiMasterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorApiMasterRequest' is not null or undefined
            assertParamExists('proxyRequest', 'vendorApiMasterRequest', vendorApiMasterRequest)
            const localVarPath = `/api/v1/vendor-api-master/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vendorApiMasterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update keyword field by ID.
         * @param {number} vendorApiId 
         * @param {KeywordUpdate} keywordUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKeyword: async (vendorApiId: number, keywordUpdate: KeywordUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorApiId' is not null or undefined
            assertParamExists('updateKeyword', 'vendorApiId', vendorApiId)
            // verify required parameter 'keywordUpdate' is not null or undefined
            assertParamExists('updateKeyword', 'keywordUpdate', keywordUpdate)
            const localVarPath = `/api/v1/vendor-api-master/keyword/{vendor_api_id}`
                .replace(`{${"vendor_api_id"}}`, encodeURIComponent(String(vendorApiId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(keywordUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Vendor Api by ID.
         * @param {number} vendorApiId 
         * @param {VendorApiMasterUpdate} vendorApiMasterUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVendorApi: async (vendorApiId: number, vendorApiMasterUpdate: VendorApiMasterUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorApiId' is not null or undefined
            assertParamExists('updateVendorApi', 'vendorApiId', vendorApiId)
            // verify required parameter 'vendorApiMasterUpdate' is not null or undefined
            assertParamExists('updateVendorApi', 'vendorApiMasterUpdate', vendorApiMasterUpdate)
            const localVarPath = `/api/v1/vendor-api-master/{vendor_api_id}`
                .replace(`{${"vendor_api_id"}}`, encodeURIComponent(String(vendorApiId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vendorApiMasterUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VendorApiMasterApi - functional programming interface
 * @export
 */
export const VendorApiMasterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VendorApiMasterApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create new Vendor Api.
         * @param {VendorApiMasterCreate} vendorApiMasterCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVendorApi(vendorApiMasterCreate: VendorApiMasterCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VendorApiMasterOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVendorApi(vendorApiMasterCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorApiMasterApi.createVendorApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Vendor Api by ID
         * @param {number} vendorApiId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVendorApi(vendorApiId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVendorApi(vendorApiId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorApiMasterApi.deleteVendorApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all unique keywords from Vendor Api.
         * @param {string | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUniqueKeywords(agentId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string | null>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUniqueKeywords(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorApiMasterApi.getAllUniqueKeywords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get latest Vendor Api by keyword.
         * @param {string} keyword Comma-separated keywords
         * @param {string | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVendorApiByKeyword(keyword: string, agentId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VendorApiMasterOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVendorApiByKeyword(keyword, agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorApiMasterApi.getVendorApiByKeyword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Vendor Api detail by ID.
         * @param {number} vendorApiId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVendorApiDetail(vendorApiId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VendorApiMasterOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVendorApiDetail(vendorApiId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorApiMasterApi.getVendorApiDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get paginated list of Vendor Api with search & sort.
         * @param {string | null} [agentId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [keyword] 
         * @param {string} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVendorApis(agentId?: string | null, page?: number, pageSize?: number, keyword?: string | null, orderBy?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedVendorApiMasterOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVendorApis(agentId, page, pageSize, keyword, orderBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorApiMasterApi.getVendorApis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send test request using Vendor Api configuration.
         * @param {VendorApiMasterRequest} vendorApiMasterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async proxyRequest(vendorApiMasterRequest: VendorApiMasterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.proxyRequest(vendorApiMasterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorApiMasterApi.proxyRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update keyword field by ID.
         * @param {number} vendorApiId 
         * @param {KeywordUpdate} keywordUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateKeyword(vendorApiId: number, keywordUpdate: KeywordUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VendorApiMasterOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateKeyword(vendorApiId, keywordUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorApiMasterApi.updateKeyword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Vendor Api by ID.
         * @param {number} vendorApiId 
         * @param {VendorApiMasterUpdate} vendorApiMasterUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVendorApi(vendorApiId: number, vendorApiMasterUpdate: VendorApiMasterUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VendorApiMasterOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVendorApi(vendorApiId, vendorApiMasterUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorApiMasterApi.updateVendorApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VendorApiMasterApi - factory interface
 * @export
 */
export const VendorApiMasterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VendorApiMasterApiFp(configuration)
    return {
        /**
         * 
         * @summary Create new Vendor Api.
         * @param {VendorApiMasterApiCreateVendorApiRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVendorApi(requestParameters: VendorApiMasterApiCreateVendorApiRequest, options?: RawAxiosRequestConfig): AxiosPromise<VendorApiMasterOut> {
            return localVarFp.createVendorApi(requestParameters.vendorApiMasterCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Vendor Api by ID
         * @param {VendorApiMasterApiDeleteVendorApiRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVendorApi(requestParameters: VendorApiMasterApiDeleteVendorApiRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteVendorApi(requestParameters.vendorApiId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all unique keywords from Vendor Api.
         * @param {VendorApiMasterApiGetAllUniqueKeywordsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUniqueKeywords(requestParameters: VendorApiMasterApiGetAllUniqueKeywordsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<string | null>> {
            return localVarFp.getAllUniqueKeywords(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get latest Vendor Api by keyword.
         * @param {VendorApiMasterApiGetVendorApiByKeywordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendorApiByKeyword(requestParameters: VendorApiMasterApiGetVendorApiByKeywordRequest, options?: RawAxiosRequestConfig): AxiosPromise<VendorApiMasterOut> {
            return localVarFp.getVendorApiByKeyword(requestParameters.keyword, requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Vendor Api detail by ID.
         * @param {VendorApiMasterApiGetVendorApiDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendorApiDetail(requestParameters: VendorApiMasterApiGetVendorApiDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<VendorApiMasterOut> {
            return localVarFp.getVendorApiDetail(requestParameters.vendorApiId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get paginated list of Vendor Api with search & sort.
         * @param {VendorApiMasterApiGetVendorApisRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendorApis(requestParameters: VendorApiMasterApiGetVendorApisRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedVendorApiMasterOut> {
            return localVarFp.getVendorApis(requestParameters.agentId, requestParameters.page, requestParameters.pageSize, requestParameters.keyword, requestParameters.orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send test request using Vendor Api configuration.
         * @param {VendorApiMasterApiProxyRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proxyRequest(requestParameters: VendorApiMasterApiProxyRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.proxyRequest(requestParameters.vendorApiMasterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update keyword field by ID.
         * @param {VendorApiMasterApiUpdateKeywordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKeyword(requestParameters: VendorApiMasterApiUpdateKeywordRequest, options?: RawAxiosRequestConfig): AxiosPromise<VendorApiMasterOut> {
            return localVarFp.updateKeyword(requestParameters.vendorApiId, requestParameters.keywordUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Vendor Api by ID.
         * @param {VendorApiMasterApiUpdateVendorApiRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVendorApi(requestParameters: VendorApiMasterApiUpdateVendorApiRequest, options?: RawAxiosRequestConfig): AxiosPromise<VendorApiMasterOut> {
            return localVarFp.updateVendorApi(requestParameters.vendorApiId, requestParameters.vendorApiMasterUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createVendorApi operation in VendorApiMasterApi.
 * @export
 * @interface VendorApiMasterApiCreateVendorApiRequest
 */
export interface VendorApiMasterApiCreateVendorApiRequest {
    /**
     * 
     * @type {VendorApiMasterCreate}
     * @memberof VendorApiMasterApiCreateVendorApi
     */
    readonly vendorApiMasterCreate: VendorApiMasterCreate
}

/**
 * Request parameters for deleteVendorApi operation in VendorApiMasterApi.
 * @export
 * @interface VendorApiMasterApiDeleteVendorApiRequest
 */
export interface VendorApiMasterApiDeleteVendorApiRequest {
    /**
     * 
     * @type {number}
     * @memberof VendorApiMasterApiDeleteVendorApi
     */
    readonly vendorApiId: number
}

/**
 * Request parameters for getAllUniqueKeywords operation in VendorApiMasterApi.
 * @export
 * @interface VendorApiMasterApiGetAllUniqueKeywordsRequest
 */
export interface VendorApiMasterApiGetAllUniqueKeywordsRequest {
    /**
     * 
     * @type {string}
     * @memberof VendorApiMasterApiGetAllUniqueKeywords
     */
    readonly agentId?: string | null
}

/**
 * Request parameters for getVendorApiByKeyword operation in VendorApiMasterApi.
 * @export
 * @interface VendorApiMasterApiGetVendorApiByKeywordRequest
 */
export interface VendorApiMasterApiGetVendorApiByKeywordRequest {
    /**
     * Comma-separated keywords
     * @type {string}
     * @memberof VendorApiMasterApiGetVendorApiByKeyword
     */
    readonly keyword: string

    /**
     * 
     * @type {string}
     * @memberof VendorApiMasterApiGetVendorApiByKeyword
     */
    readonly agentId?: string | null
}

/**
 * Request parameters for getVendorApiDetail operation in VendorApiMasterApi.
 * @export
 * @interface VendorApiMasterApiGetVendorApiDetailRequest
 */
export interface VendorApiMasterApiGetVendorApiDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof VendorApiMasterApiGetVendorApiDetail
     */
    readonly vendorApiId: number
}

/**
 * Request parameters for getVendorApis operation in VendorApiMasterApi.
 * @export
 * @interface VendorApiMasterApiGetVendorApisRequest
 */
export interface VendorApiMasterApiGetVendorApisRequest {
    /**
     * 
     * @type {string}
     * @memberof VendorApiMasterApiGetVendorApis
     */
    readonly agentId?: string | null

    /**
     * 
     * @type {number}
     * @memberof VendorApiMasterApiGetVendorApis
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof VendorApiMasterApiGetVendorApis
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof VendorApiMasterApiGetVendorApis
     */
    readonly keyword?: string | null

    /**
     * 
     * @type {string}
     * @memberof VendorApiMasterApiGetVendorApis
     */
    readonly orderBy?: string
}

/**
 * Request parameters for proxyRequest operation in VendorApiMasterApi.
 * @export
 * @interface VendorApiMasterApiProxyRequestRequest
 */
export interface VendorApiMasterApiProxyRequestRequest {
    /**
     * 
     * @type {VendorApiMasterRequest}
     * @memberof VendorApiMasterApiProxyRequest
     */
    readonly vendorApiMasterRequest: VendorApiMasterRequest
}

/**
 * Request parameters for updateKeyword operation in VendorApiMasterApi.
 * @export
 * @interface VendorApiMasterApiUpdateKeywordRequest
 */
export interface VendorApiMasterApiUpdateKeywordRequest {
    /**
     * 
     * @type {number}
     * @memberof VendorApiMasterApiUpdateKeyword
     */
    readonly vendorApiId: number

    /**
     * 
     * @type {KeywordUpdate}
     * @memberof VendorApiMasterApiUpdateKeyword
     */
    readonly keywordUpdate: KeywordUpdate
}

/**
 * Request parameters for updateVendorApi operation in VendorApiMasterApi.
 * @export
 * @interface VendorApiMasterApiUpdateVendorApiRequest
 */
export interface VendorApiMasterApiUpdateVendorApiRequest {
    /**
     * 
     * @type {number}
     * @memberof VendorApiMasterApiUpdateVendorApi
     */
    readonly vendorApiId: number

    /**
     * 
     * @type {VendorApiMasterUpdate}
     * @memberof VendorApiMasterApiUpdateVendorApi
     */
    readonly vendorApiMasterUpdate: VendorApiMasterUpdate
}

/**
 * VendorApiMasterApi - object-oriented interface
 * @export
 * @class VendorApiMasterApi
 * @extends {BaseAPI}
 */
export class VendorApiMasterApi extends BaseAPI {
    /**
     * 
     * @summary Create new Vendor Api.
     * @param {VendorApiMasterApiCreateVendorApiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorApiMasterApi
     */
    public createVendorApi(requestParameters: VendorApiMasterApiCreateVendorApiRequest, options?: RawAxiosRequestConfig) {
        return VendorApiMasterApiFp(this.configuration).createVendorApi(requestParameters.vendorApiMasterCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Vendor Api by ID
     * @param {VendorApiMasterApiDeleteVendorApiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorApiMasterApi
     */
    public deleteVendorApi(requestParameters: VendorApiMasterApiDeleteVendorApiRequest, options?: RawAxiosRequestConfig) {
        return VendorApiMasterApiFp(this.configuration).deleteVendorApi(requestParameters.vendorApiId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all unique keywords from Vendor Api.
     * @param {VendorApiMasterApiGetAllUniqueKeywordsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorApiMasterApi
     */
    public getAllUniqueKeywords(requestParameters: VendorApiMasterApiGetAllUniqueKeywordsRequest = {}, options?: RawAxiosRequestConfig) {
        return VendorApiMasterApiFp(this.configuration).getAllUniqueKeywords(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get latest Vendor Api by keyword.
     * @param {VendorApiMasterApiGetVendorApiByKeywordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorApiMasterApi
     */
    public getVendorApiByKeyword(requestParameters: VendorApiMasterApiGetVendorApiByKeywordRequest, options?: RawAxiosRequestConfig) {
        return VendorApiMasterApiFp(this.configuration).getVendorApiByKeyword(requestParameters.keyword, requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Vendor Api detail by ID.
     * @param {VendorApiMasterApiGetVendorApiDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorApiMasterApi
     */
    public getVendorApiDetail(requestParameters: VendorApiMasterApiGetVendorApiDetailRequest, options?: RawAxiosRequestConfig) {
        return VendorApiMasterApiFp(this.configuration).getVendorApiDetail(requestParameters.vendorApiId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get paginated list of Vendor Api with search & sort.
     * @param {VendorApiMasterApiGetVendorApisRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorApiMasterApi
     */
    public getVendorApis(requestParameters: VendorApiMasterApiGetVendorApisRequest = {}, options?: RawAxiosRequestConfig) {
        return VendorApiMasterApiFp(this.configuration).getVendorApis(requestParameters.agentId, requestParameters.page, requestParameters.pageSize, requestParameters.keyword, requestParameters.orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send test request using Vendor Api configuration.
     * @param {VendorApiMasterApiProxyRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorApiMasterApi
     */
    public proxyRequest(requestParameters: VendorApiMasterApiProxyRequestRequest, options?: RawAxiosRequestConfig) {
        return VendorApiMasterApiFp(this.configuration).proxyRequest(requestParameters.vendorApiMasterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update keyword field by ID.
     * @param {VendorApiMasterApiUpdateKeywordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorApiMasterApi
     */
    public updateKeyword(requestParameters: VendorApiMasterApiUpdateKeywordRequest, options?: RawAxiosRequestConfig) {
        return VendorApiMasterApiFp(this.configuration).updateKeyword(requestParameters.vendorApiId, requestParameters.keywordUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Vendor Api by ID.
     * @param {VendorApiMasterApiUpdateVendorApiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorApiMasterApi
     */
    public updateVendorApi(requestParameters: VendorApiMasterApiUpdateVendorApiRequest, options?: RawAxiosRequestConfig) {
        return VendorApiMasterApiFp(this.configuration).updateVendorApi(requestParameters.vendorApiId, requestParameters.vendorApiMasterUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

